import { SITE_URL } from "@/lib/business";

// Describe the same ordered services that visitors can browse on this page.
export function serviceListSchema(services, pathname, name) {
  return {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "@id": SITE_URL + pathname + "#services",
    name,
    numberOfItems: services.length,
    itemListElement: services.map((service, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: {
        "@type": "Service",
        "@id": SITE_URL + "/services/" + service.slug + "#service",
        name: service.name,
        url: SITE_URL + "/services/" + service.slug,
      },
    })),
  };
}
